import {
  Flex,
  Icon,
  MenuItem,
  SubmenuToggle,
  Submenu,
  Text,
  SubmenuList,
  useColorMode,
  useColorStyle,
  Box,
  Tooltip,
} from '@tonic-one/react';
import {
  AngleRightIcon,
  CheckSIcon,
  LocationIcon,
} from '@tonic-one/react-icons';
import React, { useEffect, useState } from 'react';
import { MultiTenant } from 'src/types';

import { AccountApi } from '@Apis';
import { useAccountStore } from '../../../models/useAccountModel';
import { useLoginUserStore } from '../../../models/useLoginUserModel';
import { useTranslation } from 'react-i18next';
import { logoutCleanUp } from '@Utils/common';
import SmartTooltip from '@Report/SmartTooltip';
import { useMultiTenantsStore } from '@Models/useMultiTenant';
import { useMenusItemStyle } from '@Components/CasHeader/AccountSetting/style';
import { usePermissionStore } from '@Models/usePermissionModel';

const AccountSwitch = () => {
  const { t } = useTranslation();
  const [selectedAccount, setSelectedAccount] = useState<MultiTenant | null>(
    null
  );
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const { groupCompanyGuid } = useAccountStore();
  const { user } = useLoginUserStore();
  const { multiTenants } = useMultiTenantsStore();
  const menusItemStyle = useMenusItemStyle();
  const { managementScopeIds } = usePermissionStore();
  useEffect(() => {
    const curAccount = multiTenants?.find(
      (account: MultiTenant) => account.groupCompanyGuid === groupCompanyGuid
    );
    if (curAccount) {
      setSelectedAccount(curAccount);
    }
  }, [multiTenants, groupCompanyGuid]);

  const handleClickMenuItem = async (event: any) => {
    try {
      const value = event.target.getAttribute('value');
      console.log('key', value);
      if (value) {
        const loginEmail = user ? user.loginEmail : '';
        const item =
          multiTenants?.find((item) => item.displayName === value) || null;
        if (item) {
          setSelectedAccount(item);
          await AccountApi.switchMultiTenant({
            isRoot: item.isRoot,
            toClpAccountName: value,
            multiTenantEmail: loginEmail,
            toClpGroupCompanyGuid: item.groupCompanyGuid,
          });
          logoutCleanUp();
          window.location.reload();
        }
      }
    } catch (e) {
      window.showNotification({
        titleMsg: t('common.apiException.internalError'),
        severity: 'error',
      });
      console.error(e);
    }
  };
  if (!multiTenants || multiTenants.length <= 1) {
    return null;
  }

  if (managementScopeIds !== 'all') {
    return (
      <MenuItem disabled={true}>
        <Icon as={LocationIcon} mr={6} />
        <Tooltip
          label={t('header.switchTenant.disabledMsg', {
            tenant: multiTenants[0]?.displayName,
          })}
          defaultIsOpen={false}
          bg={colorStyle.background.tertiary}
          color={colorStyle.color.primary}
        >
          <Text maxWidth={200}>
            <SmartTooltip>
              <Box as="span" color={colorStyle.color.secondary}>
                {t('common.label.tenant')}:
              </Box>{' '}
              {selectedAccount?.displayName}
            </SmartTooltip>
          </Text>
        </Tooltip>
      </MenuItem>
    );
  }
  return (
    <Submenu placement="left-start" height={36} {...menusItemStyle}>
      <SubmenuToggle width="100%">
        <Flex alignItems="center" justifyContent="space-between" width="100%">
          <Text size="sm" p="8px 12px">
            <Flex
              alignItems="center"
              justifyContent="space-between"
              width="100%"
            >
              <Icon as={LocationIcon} mr={6} />
              <Text maxWidth={200}>
                <SmartTooltip>
                  <Box as="span" color={colorStyle.color.secondary}>
                    {t('common.label.tenant')}:
                  </Box>{' '}
                  {selectedAccount?.displayName}
                </SmartTooltip>
              </Text>
            </Flex>
          </Text>
          <Flex justifyContent="flex-end">
            <Icon as={AngleRightIcon} mr={12} />
          </Flex>
        </Flex>
      </SubmenuToggle>
      {multiTenants.length > 1 && (
        <SubmenuList width="max-content" onClick={handleClickMenuItem}>
          {multiTenants.map((account) => {
            return (
              <MenuItem
                key={account.groupCompanyGuid}
                value={account.displayName}
                disabled={groupCompanyGuid === account.groupCompanyGuid}
              >
                {account.displayName}
                {groupCompanyGuid === account.groupCompanyGuid && (
                  <Icon as={CheckSIcon} ml="5px" />
                )}
              </MenuItem>
            );
          })}
        </SubmenuList>
      )}
    </Submenu>
  );
};

export default AccountSwitch;
